import { render } from "./Documents.vue?vue&type=template&id=d7f0e046&ts=true"
import script from "./Documents.vue?vue&type=script&lang=ts"
export * from "./Documents.vue?vue&type=script&lang=ts"

import exportComponent from "/data/home/cazaleres/application/cazaleres-owner/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBtn});
